// extracted by mini-css-extract-plugin
module.exports = {"followMe":"jR","linkItem":"jS","linkItemWrap":"jT","title":"jU","linkAppItemWrap":"jV","iconWrap":"jW","mfollowMe":"jX","miconWrap":"jY","followMe-dark":"jZ","followMeDark":"jZ"};